<template>
    <div class="shop__zipcodeOrWarenempfaenger">
        <div class="shop__zipcodeOrWarenempfaenger-we" v-if="ShowAddressDropdown">
            <SelectWithLabel v-model="SelectedAddressId" :label="LabelAddressPicker" :options="AvailableWEAddresses" rules="required" />
        </div>
        <div class="shop__zipcodeOrWarenempfaenger-zip" v-if="SelectedAddressId === '-1' && CurrentWE !== null">
            <ZipCityWithLabel :label="LabelZipCityPicker" rules="required" :zipCity="CurrentZipCity" @change="updateWEZipCity" />
        </div>
    </div>
</template>

<script>
    import { mapState } from 'vuex';
    import Position from '@/models/Position';
    import Address from '@/models/Address';
    import { AddressSource } from '@/utils/constants';

    export default {
        props: {
            PositionId: {
                type: Number,
                required: true
            },
            ShowPosIndex: {
                type: Boolean,
                default: true
            },
            PositionIndex: {
                type: Number,
                default: 1
            }
        },
        data() {
            return {
                SelectedAddressId: '',
                CustomAddressId: -1
            };
        },
        computed: {
            ...mapState([
                'Strings'
            ]),
            CurrentPosition() {
                return Position
                    .query()
                    .with('warenempfaenger')
                    .whereId(this.PositionId)
                    .first();
            },
            CurrentWE() {
                return this.CurrentPosition.warenempfaenger;
            },
            UsedWEAddressIds() {
                return Position
                    .query()
                    .where((pos) => { return pos.id !== this.PositionId; })
                    .get()
                    .map((pos) => { return pos.warenempfaenger_id; });
            },
            AvailableWEAddresses() {
                let addresses = Address
                    .query()
                    .where((address) => {
                        return (
                            (address.addressSource === AddressSource.ServerAddress || address.addressSource === AddressSource.MigrosLoginAddress)
                            && address.isWarenempfaenger === true
                            && !this.UsedWEAddressIds.includes(address.id)
                        )
                    })
                    .orderBy('id')
                    .get()
                    .map((addr) => { return { text: addr.dropdown_name, id: String(addr.id) } });

                addresses.push({ text: this.Strings['Shop.OptionOtherAddress'], id: '-1' });

                return addresses;
            },
            ShowAddressDropdown() {
                //more than 1 entry in AvailableWEAddresses (one is always "other")
                return this.AvailableWEAddresses.length > 1;
            },
            LabelAddressPicker() {
                return this.Strings['Shop.DeliveryAddress_BnT'] + (this.ShowPosIndex ? " " + this.PositionIndex : "");
            },
            LabelZipCityPicker() {
                return this.Strings['Shop.LabelZipCity'] + (this.ShowPosIndex ? " " + this.Strings['Shop.DeliveryAddress_BnT'] + " " + this.PositionIndex : "");
            },
            CurrentZipCity() {
                if (this.SelectedAddressId === '-1' && this.CurrentWE !== null) {
                    return { zipcode: this.CurrentWE.zipcode, city: this.CurrentWE.city, countryCode: this.CurrentWE.countryCode };
                } else {
                    return null;
                }
            }
        },
        watch: {
            SelectedAddressId(newAddressId) {
                if (newAddressId === '-1') {
                    //user selected "other address" from the dropdown -> create a blank address
                    if (this.CustomAddressId === -1) {
                        Address.new().then((newWE) => {
                            //update position to use the new WE
                            this.CustomAddressId = newWE.id;
                            Position.update({
                                id: this.PositionId,
                                warenempfaenger: newWE
                            });
                        });
                    } else {
                        //set custom address as WE
                        Position.update({
                            id: this.PositionId,
                            warenempfaenger: Address.find(this.CustomAddressId)
                        });
                    }
                } else {
                    //set serverside address as WE
                    Position.update({
                        id: this.PositionId,
                        warenempfaenger: Address.find(newAddressId)
                    });
                }
            }
        },
        methods: {
            updateWEZipCity(newZipCity) {
                this.CurrentWE.$update({ zipcode: newZipCity.zipcode, city: newZipCity.city, countryCode: newZipCity.countryCode });
            }
        },
        mounted() {
            let vm = this;

            if (vm.CurrentWE != null) {
                if (vm.CurrentWE.isServerAddress === true || vm.CurrentWE.isMigrosLoginAddress === true) {
                    vm.SelectedAddressId = String(vm.CurrentWE.id);
                } else {
                    vm.CustomAddressId = vm.CurrentWE.id;
                    vm.SelectedAddressId = '-1';
                }
            } else {
                if (vm.AvailableWEAddresses.length > 2) {
                    let weID = vm.AvailableWEAddresses[1].id;
                    Position.update({
                        id: vm.PositionId,
                        warenempfaenger: Address.find(weID)
                    }).then(() => {
                        vm.SelectedAddressId = String(weID);
                    });
                } else {
                    //no WE on position, create an empty one
                    Address.new().then((newWE) => {
                        //update position to use the new WE
                        Position.update({
                            id: vm.PositionId,
                            warenempfaenger: newWE
                        }).then(() => {
                            vm.CustomAddressId = newWE.id;
                            vm.SelectedAddressId = '-1';
                        });
                    });
                }
            }
        },
        components: {
        }
    };
</script>